import request from '../utils/request';

//直播页面
export function getLiveInfo(data) {
    return request({
        url: '/onlineExhibition/exhibitionLiveList',
        method: 'get',
        params: data,
    });
};
// 直播详情数据
export function getLiveDetail(data) {
    // console.log("拦截到的参数",data);
    return request({
        url: '/onlineExhibition/exhibitionLiveDetail',
        method: 'get',
        params: data,
    });
};
// 展商信息获取
export function getShopDetail(data) {
    return request({
        url: '/onlineExhibition/exhibitorDetails',
        method: 'get',
        params: data,
    });
};
// 收藏直播
export function getShoucang(data) {
    return request({
        url: '/onlineExhibition/addCollect',
        method: 'get',
        params: data,
    });
};